import { RootState } from "app/store";

export const selectAlarmsState = (state: RootState) =>
  state.rootReducer.alarmsStore;
